import React from "react";

const PageDescription = ({ authorName, bookTitle }) => (
  <p className="body-2 left-aligned">
    See key examples and analysis of the literary devices {authorName} uses in{" "}
    <em>{bookTitle}</em>, along with the quotes, themes, symbols, and characters
    related to each device.
  </p>
);

export default PageDescription;
